import { useI18n } from '@/lib/i18n'
import { useTRPC } from '@/lib/trpc'
import { useQuery } from '@tanstack/react-query'

function rankLabel(rank: number): string {
  if (rank === 1)
    return '🥇'
  if (rank === 2)
    return '🥈'
  if (rank === 3)
    return '🥉'
  return `#${rank}`
}

export function LeaderboardPage() {
  const { t } = useI18n()
  const trpc = useTRPC()
  const { data, isLoading } = useQuery(trpc.leaderboardRouter.topPlayers.queryOptions({}))

  const players = data?.players ?? []

  return (
    <div className="mx-auto w-full max-w-3xl px-4 pb-12 pt-24 md:px-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-foreground">{t('arenaLeaderboard.title')}</h1>
        <p className="mt-2 text-muted-foreground">{t('arenaLeaderboard.subtitle')}</p>
      </div>

      <div className="overflow-hidden rounded-lg border border-border bg-card">
        <div className="grid grid-cols-[4rem_1fr_auto] gap-4 border-b border-border bg-muted/40 px-4 py-3 text-sm font-medium text-muted-foreground">
          <span>{t('arenaLeaderboard.rank')}</span>
          <span>{t('arenaLeaderboard.player')}</span>
          <span className="text-right">{t('arenaLeaderboard.gamesPlayed')}</span>
        </div>

        {isLoading
          ? (
              <div className="px-4 py-12 text-center text-muted-foreground">
                {t('arenaLeaderboard.loading')}
              </div>
            )
          : players.length === 0
            ? (
                <div className="px-4 py-12 text-center text-muted-foreground">
                  {t('arenaLeaderboard.empty')}
                </div>
              )
            : (
                <ul>
                  {players.map(p => (
                    <li
                      key={p.rank}
                      className="grid grid-cols-[4rem_1fr_auto] items-center gap-4 border-b border-border px-4 py-3 last:border-0"
                    >
                      <span className="font-semibold tabular-nums text-muted-foreground">
                        {rankLabel(p.rank)}
                      </span>
                      <span className="truncate font-medium text-foreground">{p.name}</span>
                      <span className="text-right font-semibold tabular-nums text-foreground">
                        {p.gamesPlayed}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
      </div>
    </div>
  )
}
